<template>
    <form-checkboxes
            :name="data.slug"
            :slug="data.slug"
            :label="data.label"
            :value="data.value || []"
            :values="data.values && typeof data === 'object' ? data.values : {}"
    ></form-checkboxes>
</template>

<script>
  import CatalogDynamicFilter from 'rubinred/catalog/js/mixins/CatalogDynamicFilter';

  export default {
    mixins: [CatalogDynamicFilter],
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/catalog/assets/js/components/CatalogAttributeFilter.vue